import { useCallback } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import { formatCurrency as formatCurrencyBase } from "../OrderMFE/Orders/utils/orderUtils";
import { FALLBACK_CURRENCY_CODE } from "../constants/currency";

/**
 * Formats amounts using the company `currencyCode` from Redux when no override is passed.
 * Purchase orders / receipts may pass their own ISO code when present.
 */
export function useFormatCurrency(): (
  amount: number,
  currencyCodeOverride?: string
) => string {
  const companyCurrency = useSelector(
    (state: RootState) => state.company?.currencyCode
  );
  const defaultCode = companyCurrency ?? FALLBACK_CURRENCY_CODE;

  return useCallback(
    (amount: number, currencyCodeOverride?: string) =>
      formatCurrencyBase(amount, currencyCodeOverride ?? defaultCode),
    [defaultCode]
  );
}
